module.exports = __webpack_public_path__ + "img/vina_del_mar.47eeab5c.jpg";